import { UADAnalysisResult } from '@aloft/toolkit-shared';
import { Flex, Typography } from '@aloft/toolkit-sui';

export const UADResults = ({ data }: { data: UADAnalysisResult }) => {
  const c = data.content;
  const rows: { label: string; value?: string; commentary?: string }[] = [
    { label: 'Quality', value: c.uad_quality_rating, commentary: c.uad_quality_commentary },
    { label: 'Condition', value: c.uad_condition_rating, commentary: c.uad_condition_commentary },
    {
      label: 'Overall',
      value: '',
      commentary: c.overall_commentary,
    },
  ];
  return (
    <div style={{ borderRadius: 4, overflow: 'hidden', border: '1px solid #e0e0e0' }}>
      {rows.map(({ label, value, commentary }, i) => (
        <Flex
          key={label}
          padding="12px 16px"
          gap="16px"
          alignItems="flex-start"
          backgroundColor={i % 2 === 0 ? 'surface1' : 'surface2'}
        >
          <div style={{ minWidth: 100 }}>
            <Typography variant="h4">{label}</Typography>
          </div>
          <div style={{ minWidth: 60 }}>
            <Typography variant="h4">{value}</Typography>
          </div>
          <div style={{ flex: 1 }}>
            <Typography variant="body2" color="textSecondary">
              {commentary ?? '—'}
            </Typography>
          </div>
        </Flex>
      ))}
    </div>
  );
};
